import { InsuranceProviderType } from 'api/core/generated';

export const DEFAULT_INSURANCE_PROVIDER_TYPE = InsuranceProviderType.SEESAM;
export const DEFAULT_MAX_INSURANCE_PERIOD = 12;

export enum SigningPageViewTypes {
  signing = 'signing',
  pending = 'pending',
  pinConfirmation = 'pin-confirmation',
  preparing = 'preparing',
  signingContract = 'signing-contract',
  idCardSigning = 'id-card-signing',
  banklinkSigning = 'banklink-signing',
  signingFailed = 'signing-failed',
}
